import Card from '@components/UI/Card/Card'
import './Message.scss'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { ExecutionMessage } from '@/app/redux/reducers/activity-execution'
import MessageHeader from './MessageHeader/MessageHeader'
import { LuxButton, Color } from '@lux/wardrobe-lib'
import { BareHtml } from './BareHtml'
import Attachment from '@/app/components/UI/Attachment/Attachment'
import MessageCtaContainer from './MessageCtaContainer/MessageCtaContainer'
import { useEffect, useState } from 'react'
import MessageCommentContainer from './MessageCommentContainer/MessageCommentContainer'
import { canEditTopic, commentsActions } from '@Techedge/digitalportal-shared'

const Message = (props: {
    message: ExecutionMessage
    projectId: string
    topicMap: any
    updateTotalReactions?: (form) => void
    onAddComment?: (form) => void
    onMarkAsRead?: () => void
    onEdit?: () => void
    onStoresList: (stores) => void
    initTopic: (topicId) => void
}) => {
    const {
        message,
        projectId,
        topicMap,
        updateTotalReactions,
        onMarkAsRead,
        onEdit,
        onStoresList,
        initTopic,
    } = props
    const [showInputComment, setShowInputComment] = useState(false)
    const intl = useIntl()

    const componentClass = 'modals-new-activity-execution-message'

    useEffect(() => {
        initTopic(message.id)
    }, [])

    return (
        <div className={componentClass}>
            <Card>
                <MessageHeader
                    author={message.author}
                    creationDate={message.creationDate}
                    isUnread={message.isUnread}
                    onEdit={onEdit}
                    canEdit={canEditTopic(message)}
                />
                {message.reason && (
                    <div className={`${componentClass}__section`}>
                        <div className={`${componentClass}__title text`}>
                            {intl.formatMessage({
                                id: 'modals.new.activity.execution.messaging.reason',
                                defaultMessage: 'Message Reason',
                            })}
                        </div>
                        <div className={`${componentClass}__content text`}>
                            {intl.formatMessage({
                                id: `modals.new.activity.execution.messaging.reason.${message.reason.replace(
                                    /-/g,
                                    '.'
                                )}`,
                                defaultMessage: message.reason,
                            })}
                        </div>
                    </div>
                )}
                {message.stores.length > 0 && (
                    <div className={`${componentClass}__section`}>
                        <div className={`${componentClass}__title text`}>
                            {intl.formatMessage({
                                id: 'modals.new.activity.execution.messaging.stores',
                                defaultMessage: 'Stores',
                            })}
                        </div>
                        <div className={`${componentClass}__content text`}>
                            <LuxButton
                                text={`Stores List (${message.stores.length})`}
                                variant="text"
                                color={Color.BLUE}
                                style={{ fontSize: '12px' }}
                                onClick={() => onStoresList(message.stores)}
                            />
                        </div>
                    </div>
                )}
                <div className={`${componentClass}__section`}>
                    <div className={`${componentClass}__title text`}>
                        {intl.formatMessage({
                            id: 'modals.new.activity.execution.messaging.title',
                            defaultMessage: 'Message',
                        })}
                    </div>
                    <div className={`${componentClass}__content text`}>
                        <BareHtml.div
                            className="froala-editor-content"
                            innerHTML={{ __html: message.message }}
                        />
                    </div>
                </div>
                {message.attachmentList.map((attachment, index) => (
                    <div className={`${componentClass}__attachment`} key={index}>
                        <Attachment
                            fileExtension={attachment.file.name.split('.').pop()}
                            fileName={attachment.file.name}
                            fileUrl={attachment.url}
                            showDownloadIcon
                        />
                    </div>
                ))}
            </Card>
            <MessageCtaContainer
                onComment={() => setShowInputComment((value) => !value)}
                updateTotalReactions={updateTotalReactions}
                reactionTypeList={message.reactions.typeList}
                total={message.reactions.total}
                onMarkAsRead={onMarkAsRead}
                isUnread={message.isUnread}
                totalReply={topicMap[message.id]?.totalCount || message.totalReply}
            />
            {showInputComment && (
                <MessageCommentContainer
                    messageId={message.id}
                    storeIdList={message.stores.map((s) => s.storeId)}
                    projectId={projectId}
                />
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    topicMap: state.commentsReducer.topicMap,
})

const mapDispatchToProps = (dispatch: any) => ({
    initTopic: (topicId): string => dispatch(commentsActions.initTopic(topicId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Message)
